/*
 * @Author: Yolo
 * @Date: 2024-07-02 09:06:01
 * @Last Modified by: Yolo
 * @Last Modified time: 2024-07-02 09:09:06
 * @Desc 全球排放控制区
 */
import * as L from 'leaflet'
import { AreaViewBase } from '@map-sdk/sdk/plugins/AreaView/AreaViewBase'
import { ECAv2 } from '@map-sdk/sdk/plugins/AreaView/layer/DischargeAreaSymbolData'
import type { MyMap } from '@map-sdk/sdk/ShipxyAPISDK'
import type { AreaViewBaseOptions } from '@map-sdk/sdk/plugins/AreaView/AreaViewBase'
class DischargeAreaSymbol extends AreaViewBase {
  constructor(map: MyMap, options?: Partial<AreaViewBaseOptions>) {
    super(map, options)
    this._data = ECAv2
  }
  _show(): this {
    if (!this._data) {
      console.error('区域图形展示，请求无数据！')
      return this
    }

    for (let i = 0; i < this._data.length; i++) {
      const areas = this._data[i].area
      for (const area of areas) {
        const lines = area.line
        const latlngs1: L.LatLngExpression[] = []
        const latlngs2: L.LatLngExpression[] = []

        for (const line of lines) {
          latlngs1.push(L.latLng(line.lat, line.lon))
          latlngs2.push(L.latLng(line.lat, Number(line.lon) + 360))
        }

        if ('密闭' === this._data[i].property) {
          latlngs1.push(L.latLng(lines[0].lat, lines[0].lon))
          latlngs2.push(L.latLng(lines[0].lat, Number(lines[0].lon) + 360))
        }

        const polyline1 = L.polyline(latlngs1, {
          color: '#169316',
          dashArray: '7',
          dashOffset: '4',
          weight: 2,
          ...this.options,
        }).addTo(this._map)
        this._areaLayers.push(polyline1)

        const polyline2 = L.polyline(latlngs2, {
          color: '#169316',
          dashArray: '7',
          dashOffset: '4',
          weight: 2,
          ...this.options,
        }).addTo(this._map)
        this._areaLayers.push(polyline2)
      }
    }

    return this
  }
}

// 创建工厂函数
function dischargeAreaSymbol(
  map: MyMap,
  options: Partial<AreaViewBaseOptions>
): DischargeAreaSymbol {
  return new DischargeAreaSymbol(map, options)
}

export { DischargeAreaSymbol, dischargeAreaSymbol }
